import { render, staticRenderFns } from "./infoPlaceOrder.vue?vue&type=template&id=764c2bdd&scoped=true&"
import script from "./infoPlaceOrder.vue?vue&type=script&lang=js&"
export * from "./infoPlaceOrder.vue?vue&type=script&lang=js&"
import style0 from "./infoPlaceOrder.vue?vue&type=style&index=0&id=764c2bdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764c2bdd",
  null
  
)

export default component.exports